import { API } from './axios-config'

export default {
	fetchGroupsForProduct: function (params, callback, error) {
		console.debug('fetchGroupsForProduct', params)

		API.get('v1/groups/all', params)
			.then(response => {
				console.debug('fetchGroupsForProduct response ', response)

				var areDataValid = false

				if (response.data) {
					areDataValid = true

					callback(response.data)
				}

				if (!areDataValid) {
					error(null)
				}
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	addGroup: function (postParams, callback, error) {
		console.debug('GROUP_API addGroup', postParams)

		API.put('v1/groups',
			postParams)
			.then(response => {
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	delete: function (params, callback, error) {
		console.debug('DeviceGroup delete', params)

		API.delete('v1/groups', params).then(response => {
			// JSON responses are automatically parsed.
			console.log(response)

			callback()
		}).catch(e => {
			console.log(e)

			error(e)
		})
	}
}
